import React, { useState } from 'react';
import { PlusIcon, TrashIcon, InfoIcon, LayoutGridIcon, ListIcon } from 'lucide-react';
export function PivotSelectionStep({
  initialData = [],
  onUpdate
}) {
  const [pivots, setPivots] = useState(initialData.length ? initialData : [{
    name: '',
    length: 400,
    area: 50,
    degrees: 360,
    tradername: 'Western',
    model: 'CP600',
    price: 65000
  }]);
  const [viewMode, setViewMode] = useState('list'); // "list" or "grid"
  const handleAddPivot = () => {
    const newPivot = {
      name: '',
      length: 400,
      area: 50,
      degrees: 360,
      tradername: 'Western',
      model: 'CP600',
      price: 60000
    };
    setPivots([...pivots, newPivot]);
    onUpdate([...pivots, newPivot]);
  };
  const handleRemovePivot = index => {
    const newPivots = pivots.filter((_, i) => i !== index);
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  const handlePivotChange = (index, field, value) => {
    const newPivots = [...pivots];
    newPivots[index] = {
      ...newPivots[index],
      [field]: value
    };
    // Auto calculate area based on length and degrees
    if (field === 'length' || field === 'degrees') {
      const lengthInMeters = parseFloat(newPivots[index].length);
      const degrees = parseFloat(newPivots[index].degrees);
      const areaHa = Math.round(Math.PI * Math.pow(lengthInMeters, 2) * (degrees / 360) / 10000);
      newPivots[index].area = areaHa;
    }
    // Auto adjust price based on model and length
    if (field === 'model' || field === 'length') {
      const basePrice = field === 'model' && value === '8120' ? 70000 : 60000;
      const lengthFactor = newPivots[index].length / 400; // Adjust price based on length
      newPivots[index].price = Math.round(basePrice * lengthFactor);
    }
    setPivots(newPivots);
    onUpdate(newPivots);
  };
  return <div className="space-y-6" data-id="element-4059">
      <div className="flex justify-between items-center" data-id="element-4060">
        <div className="text-white text-xl font-medium" data-id="element-4061">
          Select Pivot Machines
        </div>
        <div className="flex bg-slate-800/50 rounded-lg p-1" data-id="element-4062">
          <button className={`p-2 rounded ${viewMode === 'list' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('list')} data-id="element-4063">
            <ListIcon size={18} data-id="element-4064" />
          </button>
          <button className={`p-2 rounded ${viewMode === 'grid' ? 'bg-blue-600 text-white' : 'text-blue-300 hover:text-white'}`} onClick={() => setViewMode('grid')} data-id="element-4065">
            <LayoutGridIcon size={18} data-id="element-4066" />
          </button>
        </div>
      </div>

      <div className="bg-blue-900/30 rounded-xl p-5 border border-blue-800/30 mb-6" data-id="element-4067">
        <div className="flex items-start" data-id="element-4068">
          <InfoIcon size={20} className="text-blue-400 mr-3 mt-0.5" data-id="element-4069" />
          <div data-id="element-4070">
            <h3 className="text-white font-medium mb-1" data-id="element-4071">
              Pivot Selection Guide
            </h3>
            <p className="text-blue-200 text-sm" data-id="element-4072">
              Select the pivot machines you want to include in this quote. You
              can add multiple pivots with different specifications. The system
              will automatically calculate coverage area based on length and
              degrees.
            </p>
          </div>
        </div>
      </div>

      {viewMode === 'list' ?
    // List View
    <div className="bg-slate-800/50 rounded-xl border border-blue-800/30" data-id="element-4073">
          <div className="grid grid-cols-12 gap-4 p-4 border-b border-blue-800/30 text-sm font-medium text-blue-300" data-id="element-4074">
            <div className="col-span-2" data-id="element-4075">Pivot Name</div>
            <div className="col-span-1 text-center" data-id="element-4076">Length (m)</div>
            <div className="col-span-1 text-center" data-id="element-4077">Area (ha)</div>
            <div className="col-span-1 text-center" data-id="element-4078">Degrees</div>
            <div className="col-span-2" data-id="element-4079">Tradername</div>
            <div className="col-span-2" data-id="element-4080">Model</div>
            <div className="col-span-2 text-right pr-8" data-id="element-4081">Price</div>
            <div className="col-span-1" data-id="element-4082"></div>
          </div>
          <div className="p-2" data-id="element-4083">
            {pivots.map((pivot, index) => <div key={index} className="grid grid-cols-12 gap-4 p-2 items-center" data-id="element-4084">
                <div className="col-span-2" data-id="element-4085">
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Pivot name" data-id="element-4086" />
                </div>
                <div className="col-span-1" data-id="element-4087">
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="100" max="1000" step="1" data-id="element-4088" />
                </div>
                <div className="col-span-1" data-id="element-4089">
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" readOnly data-id="element-4090" />
                </div>
                <div className="col-span-1" data-id="element-4091">
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" max="360" step="1" data-id="element-4092" />
                </div>
                <div className="col-span-2" data-id="element-4093">
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4094">
                    <option value="Western" data-id="element-4095">Western</option>
                    <option value="Pierce" data-id="element-4096">Pierce</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4097">
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '16px'
            }} data-id="element-4098">
                    <option value="CP600" data-id="element-4099">CP600</option>
                    <option value="8120" data-id="element-4100">8120</option>
                  </select>
                </div>
                <div className="col-span-2" data-id="element-4101">
                  <div className="relative" data-id="element-4102">
                    <span className="absolute left-3 top-2 text-gray-400" data-id="element-4103">
                      $
                    </span>
                    <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-7 pr-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-right" min="0" step="100" data-id="element-4104" />
                  </div>
                </div>
                <div className="col-span-1 flex justify-center" data-id="element-4105">
                  {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4106">
                      <TrashIcon size={16} data-id="element-4107" />
                    </button>}
                </div>
              </div>)}
          </div>
          <div className="p-4 border-t border-blue-800/30" data-id="element-4108">
            <button onClick={handleAddPivot} className="w-full py-2.5 rounded-lg border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex items-center justify-center" data-id="element-4109">
              <PlusIcon size={18} className="mr-2" data-id="element-4110" />
              Add Another Pivot
            </button>
          </div>
        </div> :
    // Grid View
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4111">
          {pivots.map((pivot, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30 relative" data-id="element-4112">
              {pivots.length > 1 && <button onClick={() => handleRemovePivot(index)} className="absolute top-4 right-4 p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4113">
                  <TrashIcon size={16} data-id="element-4114" />
                </button>}
              <h3 className="text-white font-medium mb-4" data-id="element-4115">Pivot {index + 1}</h3>
              <div className="grid grid-cols-1 gap-4 mb-4" data-id="element-4116">
                <div data-id="element-4117">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4118">
                    Pivot Name
                  </label>
                  <input type="text" value={pivot.name} onChange={e => handlePivotChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter pivot name" data-id="element-4119" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-4120">
                <div data-id="element-4121">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4122">
                    Tradername
                  </label>
                  <select value={pivot.tradername} onChange={e => handlePivotChange(index, 'tradername', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4123">
                    <option value="Western" data-id="element-4124">Western</option>
                    <option value="Pierce" data-id="element-4125">Pierce</option>
                  </select>
                </div>
                <div data-id="element-4126">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4127">
                    Model
                  </label>
                  <select value={pivot.model} onChange={e => handlePivotChange(index, 'model', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4128">
                    <option value="CP600" data-id="element-4129">CP600</option>
                    <option value="8120" data-id="element-4130">8120</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-4131">
                <div data-id="element-4132">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4133">
                    Length (m)
                  </label>
                  <input type="number" value={pivot.length} onChange={e => handlePivotChange(index, 'length', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="100" max="1000" step="1" data-id="element-4134" />
                </div>
                <div data-id="element-4135">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4136">
                    Area (ha)
                  </label>
                  <input type="number" value={pivot.area} onChange={e => handlePivotChange(index, 'area', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 bg-slate-800/70" min="1" readOnly data-id="element-4137" />
                  <div className="text-xs text-blue-400 mt-1" data-id="element-4138">
                    Auto-calculated
                  </div>
                </div>
                <div data-id="element-4139">
                  <label className="block text-sm text-blue-300 mb-1" data-id="element-4140">
                    Degrees
                  </label>
                  <input type="number" value={pivot.degrees} onChange={e => handlePivotChange(index, 'degrees', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="1" max="360" step="1" data-id="element-4141" />
                </div>
              </div>
              <div data-id="element-4142">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4143">
                  Price
                </label>
                <div className="relative" data-id="element-4144">
                  <span className="absolute left-4 top-2.5 text-gray-400" data-id="element-4145">
                    $
                  </span>
                  <input type="number" value={pivot.price} onChange={e => handlePivotChange(index, 'price', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-8 pr-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-4146" />
                </div>
              </div>
            </div>)}
          <button onClick={handleAddPivot} className="h-full min-h-[200px] rounded-xl border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex flex-col items-center justify-center" data-id="element-4147">
            <PlusIcon size={24} className="mb-2" data-id="element-4148" />
            <span data-id="element-4149">Add Another Pivot</span>
          </button>
        </div>}

      {/* Total section */}
      <div className="flex justify-end" data-id="element-4150">
        <div className="bg-slate-800/50 rounded-xl p-4 border border-blue-800/30 w-64" data-id="element-4151">
          <div className="flex justify-between items-center text-blue-300 mb-2" data-id="element-4152">
            <span data-id="element-4153">Subtotal:</span>
            <span className="text-white" data-id="element-4154">
              $
              {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
            </span>
          </div>
          <div className="border-t border-blue-800/30 pt-2 mt-2" data-id="element-4155">
            <div className="flex justify-between items-center" data-id="element-4156">
              <span className="font-medium text-white" data-id="element-4157">Total:</span>
              <span className="text-xl font-bold text-white" data-id="element-4158">
                $
                {pivots.reduce((sum, pivot) => sum + (pivot.price || 0), 0).toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}